import { useEffect, useState } from "react";
import axios from "axios";
import SummaryApi from "../../common/SummaryApi";
import ProductsRow, { ProductRowSkeleton } from "./ProductsRow";

const NewArrivals = ({ category, limit = 9 }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNewArrivals = async () => {
      try {
        setLoading(true);

        const res = await axios({
          url: SummaryApi.fetchNewArrivals.url(category),
          method: SummaryApi.fetchNewArrivals.method,
        });

        if (res.data?.success) {
          setProducts(res.data.data || []);
        } else {
          setProducts([]);
        }
      } catch (err) {
        console.error("New arrivals fetch error", err);
        setProducts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchNewArrivals();
  }, [category]);

  /* 🔥 LOADING */
  if (loading) {
    return <ProductRowSkeleton count={limit} />;
  }

  /* 🔥 EMPTY SAFE */
  if (!products.length) return null;

  return (
    <div className="bg-[#FFFFFF] py-4">

    <ProductsRow
      title="New Arrivals"
      products={products.slice(0, limit)}
      showBuyNow
    />
    </div>
  );
};

export default NewArrivals;
